import React from 'react';
import PropTypes from 'prop-types';
import MoveTo from 'moveto';
import { css } from '@bd/bdui-styles/emotion';
import FilterBar from './FilterBar';
import AppliedFilters from './AppliedFilters';
import menuToggler from '../bdcoreCandidates/menuToggler';
import { colors } from '../styles';

const styles = css`
  .FilterSort_wrapper {
    display: none;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.color3};
    padding: 60px 30px;
    overflow-y: scroll;
    &.active {
      display: block;
    }
    @media (min-width: 992px) {
      display: block;
      position: relative;
      z-index: 5;
      padding: 0;
      background-color: #FFFFFF;
      overflow-y: visible;
    }
  }
  .FilterSort_closeBtn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 15px;
    display: block;
    background-image: url('/images/icon-close-white.svg');
    background-size: 24px 24px;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    border: 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .FilterSort_doneBtn {
    margin: 15px 0 0 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .FilterSort_toggle {
    line-height: 60px;
    background-color: ${colors.color2Light};
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    border: 0;
    flex: 1;
    img {
      height: 20px;
      width: auto;
      margin: 0 10px 0 0;
    }
  }
  .Sort_button {
    position: relative;
    padding: 0 30px 0 15px;
    background-image: url('/images/icon-triangle-gold.svg');
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
    display: block;
    z-index: 2;
    cursor: pointer;
    line-height: 50px;
    background-color: #FFFFFF;
    @media (min-width: 992px) {
      position: absolute;
      padding: 0 30px 0 0;
      right: 0;
      top: 0;
    }
  }
  .Sort_buttonLabel {
    font-weight: 800;
    display: inline-block;
    @media (min-width: 992px) {
      padding: 0 0 0 30px;
      background-image: url('/images/icon-sort-gray.svg');
      background-position: left center;
      background-repeat: no-repeat;
    }
  }
  .Sort_dropdown {
    position: relative;
    list-style: none;
    padding: 0 10px;
    background: #FFFFFF;
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.50);
    background-color: ${colors.color3Lighter};
    @media (min-width: 992px) {
      width: auto;
      position: absolute;
      min-width: 200px;
      right: 0;
    }
  }
  .Sort_dropdownItem {
    font-weight: 300;
    font-size: 14px;
    color: #3F3F3F;
    border-bottom: 1px solid #CFCFCF;
    width: 100%;
    padding: 10px 0;
    cursor: pointer;
    &:last-child {
      border: 0;
    }
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .Sort_dropdownItemButton {
    width: 100%;
  }
  .AppliedFilters_clearButton {
    position: absolute;
    left: 10px;
    bottom: 10px;
    vertical-align: top;
    color: ${colors.color2};
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    @media (min-width: 992px) {
      right: 30px;
      top: 13px;
      left: auto;
    }
  }
  .ShowMap_button {
    line-height: 60px;
    background-color: ${colors.color2};
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    border: 0;
    flex: 1;
    img {
      height: 20px;
      width: auto;
      margin: 0 10px 0 0;
    }
    cursor: pointer;
  }
`;

function scrollToTop(ref) {
  setTimeout(() => {
    const moveTo = new MoveTo({
      tolerance: 100,
    });
    moveTo.move(ref);
  }, 100);
}

class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filtersOpen: false,
    };
  }

  openFilters = () => {
    this.setState({
      filtersOpen: true,
    });
  }

  closeFilters = () => {
    this.setState({
      filtersOpen: false,
    });
  }

  render() {
    const {
      activateMenu, isActiveMenu, activeSort,
      sortOptions, onSortSelect, scrollRef,
      showMap, onToggleMap, hideOnDesktop,
    } = this.props;

    const { filtersOpen } = this.state;

    return (
      <div className={`FiltersComponent ${styles}`}>
        <div className="d-flex">
          <span className="FilterSort_toggle d-lg-none" role="button" tabIndex="0" onClick={this.openFilters}>
            <img src="/images/icon-filter-white.svg" alt="" />
            <span className="FilterSort_toggleLabel">Filter &amp; Sort</span>
          </span>
          {
            onToggleMap &&
            <span className={`ShowMap_button ${hideOnDesktop && 'd-lg-none'}`} role="button" tabIndex="0" onClick={() => onToggleMap(!showMap)}>
              <img src="/images/icon-map-pin-white.svg" alt="map pin" />
              <span className="ShowMap_buttonLabel">{`${showMap ? 'Hide' : 'Show'}`} Map</span>
            </span>
          }
        </div>
        <div className={`FilterSort_wrapper ${filtersOpen && 'active'}`}>
          <button className="FilterSort_closeBtn" onClick={this.closeFilters} />
          <FilterBar
            {...this.props}
          />
          <span className="Sort_button" role="button" tabIndex="0" onClick={() => activateMenu('sort')}>
            <span className="Sort_buttonLabel">Sort By:</span> {activeSort.title}
          </span>
          {
            isActiveMenu('sort') &&
            <ul className="Sort_dropdown">
              { sortOptions.map(option => (
                <li className="Sort_dropdownItem" key={option.title}>
                  <span
                    className="Sort_dropdownItemButton"
                    role="button"
                    tabIndex="0"
                    onClick={e => {
                      e.preventDefault();
                      scrollToTop(scrollRef);
                      onSortSelect(option);
                      activateMenu();
                    }}
                  >
                    {option.title}
                  </span>
                </li>
              ))}
            </ul>
          }
          <AppliedFilters
            {...this.props}
            clearButton={<span className="ResetFilter_button">Reset Filter <img src="/images/icon-refresh-gray.svg" alt="Reset Filters Icon" /></span>}
          />
          <button className="btn FilterSort_doneBtn" onClick={this.closeFilters}>Done</button>
        </div>
      </div>
    );
  }
}

Filters.propTypes = {
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  onSortSelect: PropTypes.func.isRequired,
  onToggleMap: PropTypes.func,
  sortOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeSort: PropTypes.object.isRequired,
  scrollRef: PropTypes.object,
  showMap: PropTypes.bool,
  hideOnDesktop: PropTypes.bool,
};

Filters.defaultProps = {
  scrollRef: document.getElementsByTagName('body')[0],
  onToggleMap: undefined,
  showMap: undefined,
  hideOnDesktop: undefined,
};

export default menuToggler(Filters);



// WEBPACK FOOTER //
// ./src/components/Filters.js